var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("peppol-options"))),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _vm.settings.PeppolSendCopyToBookkeeper && _vm.bookkeeperEmail
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("send-copy-to-bookkeeper", {
                            email: _vm.bookkeeperEmail,
                          }),
                        },
                        model: {
                          value: _vm.sendCopyToBookkeeper,
                          callback: function ($$v) {
                            _vm.sendCopyToBookkeeper = $$v
                          },
                          expression: "sendCopyToBookkeeper",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.endpointItems.length > 1
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", sm: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("endpoint"),
                          items: _vm.endpointItems,
                        },
                        model: {
                          value: _vm.endpointID,
                          callback: function ($$v) {
                            _vm.endpointID = $$v
                          },
                          expression: "endpointID",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("po") },
                    model: {
                      value: _vm.po,
                      callback: function ($$v) {
                        _vm.po = $$v
                      },
                      expression: "po",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("delivery-number") },
                    model: {
                      value: _vm.deliveryNumber,
                      callback: function ($$v) {
                        _vm.deliveryNumber = $$v
                      },
                      expression: "deliveryNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "12" } },
                [
                  _c(
                    "app-file-upload",
                    {
                      attrs: { "max-size": _vm.maxFileSize, multiple: "" },
                      on: {
                        input: function ($event) {
                          return _vm.onFileInput($event)
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "paperclip" } }),
                      _vm._v(" " + _vm._s(_vm.$ct("upload-attachment")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            _vm._l(_vm.files, function (item, i) {
              return _c("w-col", { key: i, attrs: { xs: "12" } }, [
                _c(
                  "div",
                  { staticClass: "file" },
                  [
                    _vm._v(" " + _vm._s(item.name) + " "),
                    _c("w-spacer"),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("remove-attachment"),
                            expression: "$ct('remove-attachment')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFile(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.ok")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }